import apiClient from './apiClient';

const normalizeFinding = (f) => ({ ...f, severity: String(f?.severity || 'MEDIUM').toLowerCase(), status: String(f?.status || 'OPEN').toLowerCase(), assignedTo: f?.assignedTo ?? f?.assignedToUserId ?? null });
const toFindingPayload = (p) => ({ ...p, ...(p.severity != null && { severity: String(p.severity).toUpperCase() }), ...(p.status != null && { status: String(p.status).toUpperCase() }) });

export async function fetchVulnerabilityFindings() {
  const { data } = await apiClient.get('/vulnerability-management/findings');
  return data.map(normalizeFinding);
}

export async function patchVulnerabilityFinding(id, changes) {
  const { data } = await apiClient.patch(`/vulnerability-management/findings/${id}`, toFindingPayload(changes));
  return normalizeFinding(data);
}

export async function createVulnerabilityFinding(payload) {
  const { data } = await apiClient.post('/vulnerability-management/findings', {
    title: payload.title,
    cveId: payload.cveId || null,
    severity: payload.severity || null,
    assetId: payload.assetId || null,
  });
  return normalizeFinding(data);
}
